define(["require", "exports", "UI/StatusIndicator"], function (require, exports, StatusIndicator_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FileUploader = void 0;
    class FileUploader extends StatusIndicator_1.StatusIndicator {
        constructor(options) {
            super();
            this.ClearFiles = () => {
                $(`#${this.Id()}`).val('');
                this.FileList(null);
            };
            this.StartUpload = () => {
                this.SetStatus(StatusIndicator_1.Status.Loading);
            };
            this.HandleUpload = () => {
                this.FileList($(`#${this.Id()}`).prop('files'));
                this.SetStatusAfterDelay(StatusIndicator_1.Status.Success);
                console.log(this.FileList());
            };
            ko.mapping.fromJS(options, {}, this);
            this.FileList = ko.observable(null);
            this.HasFiles = ko.computed(() => this.FileList() && this.FileList().length > 0);
        }
    }
    exports.FileUploader = FileUploader;
});
//# sourceMappingURL=FileUploader.js.map